const Header = ({ children }) => children
Header.displayName = 'Header'
export default Header
